import { render, staticRenderFns } from "./EmissaoDaps.vue?vue&type=template&id=5bebb504&scoped=true&"
import script from "./EmissaoDaps.vue?vue&type=script&lang=js&"
export * from "./EmissaoDaps.vue?vue&type=script&lang=js&"
import style0 from "./EmissaoDaps.vue?vue&type=style&index=0&id=5bebb504&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bebb504",
  null
  
)

export default component.exports